import axiosInstance from "../../../axios";

const updateResource = async (id, payload) => {
  try {
    const { data } = await axiosInstance.patch(`/resources/${id}`, payload);
    return data;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

const cloneResources = async (reqBody) => {
  try {
    const { data } = await axiosInstance.post(
      `resources/copy-resource`,
      reqBody
    );
    return data;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

const cancelSession = async (id) => {
  try {
    const { data } = await axiosInstance.patch(`sessions/postponed/${id}`);
    return data;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

const addQuestion = async (quizId, payload) => {
  try {
    const { data } = await axiosInstance.post(
      `/quiz/question/add/${quizId}`,
      payload
    );
    return data;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

const getQuiz = async (quizId) => {
  try {
    const { data } = await axiosInstance.get(`/quiz/${quizId}`);
    return data;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const SessionAPI = {
  updateResource,
  cloneResources,
  cancelSession,
  addQuestion,
  getQuiz
};
